import { takeUntil } from 'rxjs/operators';
import { Component, OnInit, Input, ViewChild, AfterContentChecked, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AlertController, isPlatform, ModalController, ToastController } from '@ionic/angular';
import * as fromAccountSelector from 'src/app/store/selectors/account.selectors';
import * as fromOrgSelector from 'src/app/store/selectors/organization.selectors';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { QRCodeService } from 'src/app/services/qrcode.service';
import { UserProfile } from 'src/app/models/user-profile.model';
import * as QRCode from 'qrcode';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Media } from '@capacitor-community/media';

import { environment } from 'src/environments/environment';
import { setLoadingSpinner } from 'src/app/store/actions/shared.actions';
import { Sim } from '@ionic-native/sim/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { OrganizationService } from 'src/app/services/organization.service';
import { getUserOrganizationPoints } from 'src/app/store/actions/organization.actions';
import { ScreenBrightness, SetBrightnessOptions } from '@capacitor-community/screen-brightness';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { Screenshot } from 'capacitor-screenshot';
import { format } from 'date-fns';

@Component({
  selector: 'app-appointment-qr',
  templateUrl: './appointment-qr.component.html',
  styleUrls: ['./appointment-qr.component.scss'],
})
export class AppointmentQrComponent implements OnInit {

  @Input() appointment: any;
  @Input() fromResponse: any;

  currDate: Date = new Date();
  activeSliderIndex: number = 0;
  activeSlide: any = [];

  userProfile$: Observable<any>;
  userProfile: UserProfile;

  originalBrightness: any;

  activeQr: any;

  ngUnsubscribe = new Subject();

  timerCtr = environment.resendVerification;
  interval;

  carrierName = '';

  qrAds: any = [];

  onCapture = false;

  qrcode: any;

  eventQrLoading = false;

  adsSwiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 40,
    centeredSlides: true,
    navigation: false,
    pagination: false
  }
  
  constructor(
    public toastController: ToastController,
    private qrCodeService: QRCodeService,
    private modalCtrl: ModalController,
    private store: Store<AppState>,
    private sim: Sim,
    private androidPermissions: AndroidPermissions,
    private organizationService: OrganizationService,
    private alertCtrl: AlertController
  ) {
    this.userProfile$ = this.store.select(fromAccountSelector.getUser);
  }
    
  ngOnInit() {
    this.getSimValue();

    console.log(this.appointment);

    this.userProfile$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((userProfile) => {
      if (userProfile) {
        this.userProfile = userProfile;
        this.loadQrs();
      }
    });

    this.organizationService.getQrAds().subscribe((res) => {
      if(res){
        console.log({res});
        this.qrAds = res?.details;
      }
    });
  }

  async ionViewWillEnter(){
    const brightness = await ScreenBrightness.getBrightness();
    console.log({brightness});
    this.originalBrightness = brightness.brightness;

    const brightnessValue = 1.0;
    await ScreenBrightness.setBrightness({brightness: brightnessValue});
  }

  async ionViewWillLeave(){
    const brightnessValue = this.originalBrightness;
    await ScreenBrightness.setBrightness({brightness: brightnessValue});
  }

  loadQrs() {
    this.eventQrLoading = true;
    this.qrCodeService.processAppointmentQr(this.appointment, this.userProfile, this.carrierName).then((res) => {
      if(res){
        console.log('this.qrCodeService.processAppointmentQr', this.carrierName);
        this.qrcode = res;
        this.eventQrLoading = false;
        console.log({res});
      }
    })
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  take(){
    this.onCapture = true;
    
    setTimeout(() => {
      Screenshot.take().then(async (ret: { base64: string }) => {
        if(ret){
          this.onCapture = false;
          const imgUrl = `data:image/png;base64,${ret.base64}`;
          try { 
            const imageTempFile = `${new Date().getTime()}.jpeg`;
            const imgBase64Data = imgUrl.replace(/^data:image\/(png|jpg);base64,/, "");
            const imgTemp = await Filesystem.writeFile({
              path: imageTempFile,
              data: imgBase64Data,
              directory: Directory.Cache
            });
  
            const albumName = 'GETPASS_Mobile';
            let albumIdentifier = '';
  
            if (isPlatform('ios')) {
              // Handle albums
              let albums = await Media.getAlbums();
              albumIdentifier = albums.albums.find(a => a.name === albumName)?.identifier || null;
  
              if (!albumIdentifier) {
                // Doesn't exist, create new album
                await Media.createAlbum({ name: albumName });
                albums = await Media.getAlbums();
                albumIdentifier = albums.albums.find(a => a.name === albumName)?.identifier;
              }
            } else if (isPlatform('android')) {
              let albums = await Media.getAlbums();
              const album = albums.albums.find(a => a.name === albumName)?.identifier;
              if (!album) {
                  await Media.createAlbum({ name: albumName });
              }
            }
            console.log(imageTempFile)
            Media.savePhoto({
              path: imgTemp.uri,
              album: (isPlatform('ios')) ? { name: albumIdentifier } : { name: albumName},
            }).then(async () => 
            {
                const toast = await this.toastController.create({
                  message: 'QR has been saved.',
                  position: 'bottom',
                  duration: 2000,
                  color: 'success'
                });
                toast.present();
              
            })
            .catch(async e => 
              {
                const toast = await this.toastController.create({
                  message: e,
                  position: 'bottom',
                  duration: 2000,
                  color: 'danger'
                });
                
                toast.present();
            });
          } catch (e) { 
  
            const toast = await this.toastController.create({
              message: e,
              position: 'bottom',
              duration: 2000,
              color: 'danger'
            });
            toast.present();
          }
        }
      });
    }, 100);
  }

  dismiss() {
    if(this.fromResponse){
      this.confirmDismiss();
    }
    else{
      this.modalCtrl.dismiss();
    }
  }

  async getSimValue() {
    if (isPlatform('capacitor')) {
      if (isPlatform('ios')) {
        const simData = await this.sim.getSimInfo();
        console.log('Sim info: ', simData);
        if (simData) {
          this.carrierName = simData.carrierName;
          this.loadQrs();
        }
      } else {
        let permissionCtr = 0;
        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_PHONE_STATE).then(result => {
          if (result.hasPermission) {
            permissionCtr++;
          }
        });
        if (permissionCtr >= 1) {
          const hasReadPermission = await this.sim.hasReadPermission();
          if (hasReadPermission) {
            const simData = await this.sim.getSimInfo();
            console.log('Sim info: ', simData);
            if (simData) {
              this.carrierName = simData.carrierName;
              if (simData.cards && simData.cards.length > 0) {
                if (simData.cards[0].carrierName !== 'No network connection') {
                  this.carrierName = simData.cards[0].carrierName;
                  this.loadQrs();
                }
              }
              if (simData.cards && simData.cards.length > 1) {
                if (simData.cards[1].carrierName !== 'No network connection') {
                  this.carrierName = this.carrierName + '&' + simData.cards[1].carrierName;
                  this.loadQrs();
                }
              }
            }
          } else {
            const simData = await this.sim.getSimInfo();
            console.log('Sim info: ', simData);
            if (simData) {
              this.carrierName = simData.carrierName;
              this.loadQrs();
            }
          }
        } else {
          console.warn('Getting SIM info has no permissions ');
        }
      }
    } 
  }

  formatDate(date){
    return format(new Date(date), "MMMM dd, yyyy, EEEE");
  }

  formatTime(date){
    return format(new Date(date), "h:mm a");
  }

  async confirmDismiss() {
    const alert = await this.alertCtrl.create({
      header: 'Close Modal',
      message: 'Are you sure you want to close this modal? Please make sure to download or screenshot this QR before closing',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            this.alertCtrl.dismiss();
          }
        },{
          text: 'Continue',
          handler: async () => {
            this.alertCtrl.dismiss();
            this.modalCtrl.dismiss();
          }
        }
      ]
    });

    return alert.present();
  }
}
